module.exports = __webpack_public_path__ + "static/book_small-0d6caca29d98be3a60ee2fe4b5f9cadc.png";